import { render, staticRenderFns } from "./SuspendedAccess.vue?vue&type=template&id=283cc023&"
import script from "./SuspendedAccess.vue?vue&type=script&lang=js&"
export * from "./SuspendedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports